import { SuiteManifest } from '../manifest';
import { operationsRoutes } from './routes';
import { operationsNavItems } from './nav';

export const operationsManifest: SuiteManifest = {
  id: 'operations',
  name: 'Operations & Supply Chain',
  basePath: '/operations',
  icon: 'package',
  description: 'End-to-end supply chain, multi-site warehouse inventory, manufacturing, and field dispatch.',
  nav: operationsNavItems,
  routes: operationsRoutes,
};

export default operationsManifest;
